import { get, isMockMode, simulateDelay } from "../api";

export const getServiceById = ({ offeringId }) => {
	if (isMockMode()) {
		const testData = {
			id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			name: "Test Name",
			description: "the most rad description",
			ownerNotes: null,
			numDaysToExpireLicenceCache: 30,
			businessManagers: [{ email: "test.mctestie@mgaol.abc" }],
			productDevelopers: [],
			techSupports: [],
			currentInstaller: null,
		};

		return simulateDelay(50, () => testData);
	}

	return get(`Services/AdminGetById?offeringId=${offeringId}`);
};
